var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-pagination',{attrs:{"current":_vm.page,"total":_vm.total ? _vm.total : 0,"pageSize":_vm.size,"show-total":_vm.onShowTotal,"showSizeChanger":""},on:{"change":_vm.handleChangePagination,"showSizeChange":_vm.handleChangePagination}})
}
var staticRenderFns = []

export { render, staticRenderFns }